var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    role: "img",
    width: "26px",
    height: "25px",
    viewBox: "0 0 35 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-wishlist"
  }, "Wishlist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-wishlist"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav---Black",
    transform: "translate(-1209.000000, -13.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1148.353846, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wishlist",
    transform: "translate(61.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8780539,30 C16.6957855,30 16.5135171,29.9270926 16.3677024,29.7812779 L2.9527481,16.4027773 C1.05715673,14.4707322 -9.71321163e-16,11.9189746 -9.71321163e-16,9.22140226 C-9.71321163e-16,6.52382993 1.05715673,3.97207231 2.98920178,2.04002726 C4.84833947,0.144435886 7.40009709,-0.438822998 10.3528452,0.326704287 C12.540066,0.909963171 14.9095552,2.29520302 16.8780539,4.11788703 C18.8465527,2.29520302 21.1795882,0.909963171 23.4032627,0.326704287 C26.3560108,-0.438822998 28.9077684,0.144435886 30.8033598,2.04002726 L30.8033598,2.04002726 L30.8033598,2.04002726 C32.7354049,3.97207231 33.7925616,6.52382993 33.7925616,9.22140226 C33.7925616,11.9189746 32.7354049,14.4707322 30.8033598,16.4027773 L17.3884055,29.7812779 C17.2425908,29.9270926 17.0603224,30 16.8780539,30 Z M7.94690229,1.45676837 C6.6345698,1.45676837 5.21287627,1.82130518 4.00990483,3.02427662 C2.36948922,4.66469224 1.45814721,6.85191305 1.45814721,9.18494858 C1.45814721,11.5179841 2.36948922,13.7052049 4.00990483,15.3456205 L16.8780539,28.2502233 L29.7462031,15.3820742 C31.3866187,13.7416586 32.2979607,11.5544378 32.2979607,9.22140226 C32.2979607,6.88836673 31.3866187,4.70114592 29.7462031,3.0607303 L29.7462031,3.0607303 C27.8506117,1.16513893 25.4446688,1.31095365 23.7677995,1.74839782 C21.6170324,2.29520302 19.3204505,3.71689655 17.4613128,5.57603424 L17.3884055,5.6489416 C17.096776,5.94057104 16.6593319,5.94057104 16.3677024,5.6489416 L16.2947951,5.57603424 C14.4356574,3.71689655 12.1390755,2.29520302 9.9518547,1.74839782 C9.36859582,1.6025831 8.6759759,1.45676837 7.94690229,1.45676837 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.2d2f60e219bec7e65791eebd58da6092.svg";
export { ForwardRef as ReactComponent };